export const TYPES = {
  SHOW_CONTROL: 'SHOW_CONTROL',
  HIDE_CONTROL: 'HIDE_CONTROL',
  TOGGLE_CONTROL: 'TOGGLE_CONTROL',
};

export const showControl = (data, content) => ({
  type: TYPES.SHOW_CONTROL,
  data,
  content,
});
export const toggleControl = (data, content) => ({
  type: TYPES.TOGGLE_CONTROL,
  data,
  content,
});
export const hideControl = () => ({ type: TYPES.HIDE_CONTROL });



/** WEBPACK FOOTER **
 ** ./src/redux/actions/customControlActions.js
 **/